import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { GorusmeNotuEditComponent } from './gorusme-notu-edit.component';
import { GorusmeNotuKartComponent } from './gorusme-notu-kart.component';

@DinamikBilesen({
  id: 'gorusme-notu',
  baslik: 'Görüşme Notu',
  aciklama: 'Müşteri görüşme notu ekle',
  ikon: 'message',
  kategori: 'satis',
})
class GorusmeNotu {
  paylas_kutusu = GorusmeNotuEditComponent;
  paylasilmis_kart = GorusmeNotuKartComponent;
}
